import {
  AccountInfo,
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    authority: "https://login.microsoftonline.com/" + import.meta.env.VITE_TENANT_ID,
    clientId: import.meta.env.VITE_CLIENT_ID || "",
    redirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const pca = new PublicClientApplication(msalConfig);
await pca.initialize();

const accounts = pca.getAllAccounts();
if (accounts.length > 0) pca.setActiveAccount(accounts[0]);

pca.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    pca.setActiveAccount(account);
    if (payload.state) window.location.pathname = payload.state;
  }
});

pca.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    pca.setActiveAccount(account);
  }
});

export const authRequest = {
  scopes: ["api://" + import.meta.env.VITE_API_CLIENT_ID + "/access_as_user"],
  state: window.location.pathname,
};

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[];
  };
}

export type Role = "Admin" | "Betrieb" | "Technik" | "Netzwirtschaft" | "Netzplanung" | "Gast" | "Backend" | "Everyone";

export function isAuthorized(requiredRoles: Role[]): boolean {
  if (requiredRoles.includes("Everyone")) {
    return true;
  }

  const account: Account | null = pca.getActiveAccount();
  const userRoles = account?.idTokenClaims?.roles;

  if (userRoles) {
    return requiredRoles.filter((element) => userRoles.includes(element)).length > 0;
  } else {
    return false;
  }
}
